import { connect } from 'react-redux';
import MainReports from 'components/reports/MainReports';

const mapStateToProps = (state, ownProps) => {
  return {
    partyType: state.app.lookups.partyTypes.find(
      p => p.ID === state.app.user.PartyType
    ),

    // fetching: state.reports.fetchingReportData,

    // auctionsPerInsurance: state.reports.auctionsPerInsurance,
    // fetchingAuctionsPerInsurance: state.reports.fetchingAuctionsPerInsurance,

    // auctionsPerMerchant: state.reports.auctionsPerMerchant,
    // fetchingAuctionsPerMerchant: state.reports.fetchingAuctionsPerMerchant,

    // auctionsPerExpert: state.reports.auctionsPerExpert,
    // fetchingAuctionsPerExpert: state.reports.fetchingAuctionsPerExpert,

    // insurances: state.app.lookups.insurances,
    // merchants: state.app.lookups.merchants,
    // experts: state.app.lookups.experts
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    // fetchByInsurance: opts => dispatch(fetchAuctionsReportData(Object.assign(opts, { group: 'insurances' }))),
    // fetchByMerchant: opts => dispatch(fetchAuctionsReportData(Object.assign(opts, { group: 'merchants' }))),
    // fetchByExpert: opts => dispatch(fetchAuctionsReportData(Object.assign(opts, { group: 'experts' })))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainReports);
